import InvoicesOutgoing from '@/views/invoices/Outgoing.vue'

const router = {
    path: '/invoices/outgoing',
    name: 'Outgoing Invoices',
    component: InvoicesOutgoing,
    meta: {
        title: 'Outgoing Invoices'
    }
  };

export default router
